<script setup lang="ts">
// Define the component name to fix the linter error
defineOptions({
  name: 'DiplomacyAlliance'
})

import { useAllianceStore } from '@/stores/allianceStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'
import AllianceAsLeader from './AllianceAsLeader.vue'
import AllianceAsMember from './AllianceAsMember.vue'
import AllianceNone from './AllianceNone.vue'

const allianceStore = useAllianceStore()
const gameStore = useGameStore()

// Determine if current player is the alliance leader
const isAllianceLeader = computed(() => {
  if (!gameStore.player?.allianceId) {
    return false
  }
  const alliance = allianceStore.alliances.get(gameStore.player.allianceId)

  return alliance?.leaderPlayerId === gameStore.player?.id
})
</script>

<template>
  <div class="pb-2 pt-1 w-full xl:w-2/3 mx-auto px-2 md:px-0">
    <AllianceNone v-if="gameStore.player?.allianceId === 0" />
    <AllianceAsLeader v-else-if="isAllianceLeader" />
    <AllianceAsMember v-else />
  </div>
</template>

<style scoped lang="scss"></style>
